import classNames from 'classnames';
import { Image } from 'components/modulab/Image';
import React from 'react';

interface ProviderCardListProps {
  isSelected: boolean;
  providerName?: string;
  providerImage?: string;
}

export const ProviderCard: React.FC<ProviderCardListProps> = ({
  isSelected,
  providerImage,
  providerName,
}) => {
  return (
    <div className="w-full">
      <div
        className={classNames(
          'outline outline-1 outline-primary-100 rounded-xl flex justify-center bg-white h-16 w-full p-4 transition-all',
          {
            'outline-primary-500 outline-2': isSelected,
          },
        )}
      >
        <Image
          src={providerImage}
          alt={providerName}
          objectFit="contain"
          layout="fill"
        />
      </div>
    </div>
  );
};
